import { useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import { capitalizeFirstLetter } from 'src/utils/string';

import InputNumber from 'src/componentes/input-number';
import Lookup from './lookup';
import { FormGroup, Input, Label } from 'src/componentes/Form';
import { useIntl } from 'react-intl';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';
import Panel from 'src/componentes/panel';
import useAuth from 'src/hooks/useAuth';
import ContentManager from 'src/componentes/content-manager';
import { TIPO_CAMPO_CUSTOMIZADO } from 'src/utils/constants';
import AcaoList from 'src/paginas/acao/select-list';
import TabelaItensAssociados from 'src/paginas/gestao-risco/perda-operacional/Componentes/ItensAssociados/relacionamento';
import ItensAssociados from 'src/paginas/gestao-risco/perda-operacional/Componentes/ItensAssociados';

export default function PerguntasCampoCustomizado({
  resources,
  perdaOperacionalId,
  colValue = null,
  mdFields = 3,
  model,
  desconsiderarObrigatorio,
  mdFieldsTo,
  itensAssociados,
  onChangeItensAssociados,
  showErrors = false,
  hasErrors = () => false,
  utilizarRelacionamentoItens = false,
  utilizarPlanoAcao = false,
  usuarioPodeModificarPlanoAcao = false,
  usuarioPodeModificarItensAssociados = false,
  ...rest
}) {
  const intl = useIntl();
  const { configurations, modules } = useAuth();
  const tiposAnexos = configurations?.tiposAnexos;

  const handleChange = (index, item, justificativa = false, field = '') => {
    let itens = model.value;
    if (index !== -1) {
      if (justificativa) {
        itens[index].justificativa = item;
      } else if (field) {
        itens[index][field] = item;
      } else {
        itens[index].valor = item;
      }
    }

    model.requestChange(itens);
  };

  const isCampoCustomizadoSemValor = (item) => {
    if (item?.campo?.multiSelecao) {
      return !item?.campo?.valores || item.campo.valores.length <= 0;
    }

    return item.valor == null || item.valor == '';
  };

  const handleHasErrors = () => {
    if (model.value && model.value.length > 0) {
      for (let i = 0; i < model.value.length; i++) {
        const item = model.value[i];
        if (item.campo.obrigatorio && isCampoCustomizadoSemValor(item)) {
          return true;
        }
      }
    }

    return false;
  };

  useEffect(() => {
    if (showErrors) {
      hasErrors(handleHasErrors());
    }
  }, [model?.value]);

  const handleLookupChange = (index, item) => {
    let itens = model.value;

    if (index !== -1) {
      itens[index].valor = item ? item.id : null;
    }

    model.requestChange(itens);
  };

  const handleLookupChangeMulti = (index, item) => {
    let itens = model.value;
    if (index !== -1)
      itens[index].campo.valores = item.map((i) =>
        itens[index].campo.opcoesTabela.find((op) => op.id == i.id)
      );
    model.requestChange(itens);
  };

  const handleOpenItensAssociados = () => {
    ContentManager.addContent(
      <ItensAssociados
        modules={modules}
        model={{
          value: itensAssociados,
          requestChange: onChangeItensAssociados,
        }}
        habilitarIndicadoresRisco={true}
      />
    );
  };

  const renderAnexarEvidencia = (item, index, errors, disabled) => {
    const hasErrorRequired =
      showErrors &&
      !disabled &&
      !item.disabled &&
      item.evidenciaObrigatoria &&
      !disabled &&
      (!item.anexos || item.anexos.length == 0);

    return (
      item.usarEvidencia && (
        <ArquivoUploadAnexos
          required={item.evidenciaObrigatoria && !disabled}
          onlyOneFile={false}
          onlyRead={disabled || item.disabled}
          rightLabel={true}
          classNameFormGroup="d-flex inline pt-1"
          maxWidth={'250px'}
          tipoAnexo={tiposAnexos.perdaOperacionalAnalise}
          formGroupStyle={{
            marginBottom: 0,
            maxWidth: '250px',
            color: hasErrorRequired ? '#FF0000' : null,
          }}
          model={{
            value: item?.anexos,
            label: intl.formatMessage({ id: 'labelAnexarEvidencia' }),
            requestChange: (value) =>
              handleChange(index, value, false, 'anexos'),
            errors: hasErrorRequired,
          }}
        />
      )
    );
  };

  const renderHeader = (item, required, index = 0) => {
    return (
      <div
        className="pb-0 pl-3 align-items-center justify-content-left d-flex"
        style={{
          color: '#FFF',
          backgroundColor: '#237788',
          minHeight: '54px',
        }}
      >
        <Label className="p-3 m-0">
          {index + 1 + '. '}
          {item.campo.nome}
          {required ? ' *' : ''}
          {/* {item.usarRevisao
            ? ` (${intl.formatMessage({ id: 'label.revisao' })})`
            : ''} */}
        </Label>
      </div>
    );
  };

  const renderHeaderPlanoAcao = () => {
    return (
      <div
        className="pb-0 pl-3 align-items-center justify-content-left d-flex"
        style={{
          color: '#FFF',
          backgroundColor: '#237788',
          minHeight: '54px',
        }}
      >
        <Label className="p-3 m-0">
          {capitalizeFirstLetter(resources.planodeacao)}
        </Label>
      </div>
    );
  };

  const renderJustificativa = (item, index, errors, disabled) => {
    if (!item.usarJustificativa) return;

    const required =
      item?.justificativaObrigatoria && !item.disabled && !disabled;

    const hasErrorRequired =
      required &&
      showErrors &&
      !item.justificativa &&
      !item.disabled &&
      !disabled;

    return (
      <div className="pt-3">
        <Label
          className="p-0 pb-2 m-0"
          style={{ color: hasErrorRequired ? '#FF0000' : '' }}
        >
          {intl.formatMessage({ id: 'justificativa' })}
          {required ? ' *' : ''}
        </Label>
        <Input
          disabled={disabled || item.disabled}
          required={required}
          onBlur={rest.getAlteracao}
          type="textarea"
          rows={rest.rowsTextArea ? rest.rowsTextArea : '2'}
          value={item.justificativa}
          onChange={(value) => handleChange(index, value.target.value, true)}
          errors={hasErrorRequired}
          maxLength={30000}
        />
      </div>
    );
  };

  const desenharCampoCustomizado = (item, index, desconsiderarObrigatorio) => {
    const visible = item.campo.visivel == null || item.campo.visivel;
    const required = item?.campo?.obrigatorio && !desconsiderarObrigatorio;
    const errors =
      showErrors &&
      required &&
      !rest.ignoreErrors &&
      isCampoCustomizadoSemValor(item);

    if (!visible) return;

    const disabled = rest.customIsDisabledValidation
      ? rest.customIsDisabledValidation(item)
      : item.disabled;

    const { maxLength } = rest;
    if (item.campo.tipo.id === TIPO_CAMPO_CUSTOMIZADO.TEXTO) {
      return (
        <FormGroup>
          {renderHeader(item, required, index)}
          <div className="pt-3">
            <Input
              style={{
                height: '33px',
                borderColor:
                  errors && !disabled && !item.disabled ? '#FF0000' : '',
              }}
              required={required && !disabled}
              maxLength={maxLength ? maxLength : 3000}
              onBlur={rest.getAlteracao}
              disabled={disabled}
              value={item.valor}
              errors={errors}
              onChange={(value) => handleChange(index, value.target.value)}
            />
          </div>
          {renderJustificativa(item, index, errors, disabled)}
          {renderAnexarEvidencia(item, index, errors, disabled)}
        </FormGroup>
      );
    }
    if (item.campo.tipo.id === TIPO_CAMPO_CUSTOMIZADO.MULTILINHA) {
      return (
        <FormGroup>
          {renderHeader(item, required, index)}
          <div className="pt-3">
            <Input
              disabled={disabled || item.disabled}
              required={required}
              style={{
                borderColor:
                  errors && !disabled && !item.disabled ? '#FF0000' : '',
              }}
              onBlur={rest.getAlteracao}
              type="textarea"
              rows={rest.rowsTextArea ? rest.rowsTextArea : '2'}
              value={item.valor}
              onChange={(value) => handleChange(index, value.target.value)}
              errors={errors}
              maxLength={maxLength ? maxLength : 3000}
            />
          </div>
          {renderJustificativa(item, index, errors, disabled)}
          {renderAnexarEvidencia(item, index, errors, disabled)}
        </FormGroup>
      );
    }
    if (item.campo.tipo.id === TIPO_CAMPO_CUSTOMIZADO.INTEIRO) {
      return (
        <FormGroup>
          {renderHeader(item, required, index)}
          <div className="pt-3">
            <InputNumber
              style={{ height: '33px' }}
              required={required}
              onBlur={rest.getAlteracao}
              precision={0}
              disabled={disabled || item.disabled}
              model={{
                errors: errors && !disabled && !item.disabled,
                value: item.valor,
                //label: item.campo.nome,
                requestChange: (value) => handleChange(index, value),
              }}
            />
          </div>
          {renderJustificativa(item, index, errors, disabled)}
          {renderAnexarEvidencia(item, index, errors, disabled)}
        </FormGroup>
      );
    }
    if (item.campo.tipo.id === TIPO_CAMPO_CUSTOMIZADO.DECIMAL) {
      return (
        <FormGroup>
          {renderHeader(item, required, index)}
          <div className="pt-3">
            <InputNumber
              style={{ height: '33px' }}
              required={required}
              onBlur={rest.getAlteracao}
              precision={2}
              disabled={disabled || item.disabled}
              model={{
                errors: errors && !disabled && !item.disabled,
                value: item.valor,
                requestChange: (value) => handleChange(index, value),
              }}
            />
          </div>
          {renderJustificativa(item, index, errors, disabled)}
          {renderAnexarEvidencia(item, index, errors, disabled)}
        </FormGroup>
      );
    }
    if (item.campo.tipo.id === TIPO_CAMPO_CUSTOMIZADO.VALOR_TABELADO) {
      if (item.campo.multiSelecao) {
        return (
          <FormGroup>
            {renderHeader(item, required, index)}
            <div className="pt-3 pb-2">
              <Lookup
                required={required}
                onBlur={rest.getAlteracao}
                disabled={disabled || item.disabled}
                options={item.campo.opcoesTabela}
                multi
                multiValueWrapper={'max-width: 300px;'}
                model={{
                  errors: errors && !disabled && !item.disabled,
                  value:
                    item.campo.valores &&
                    item.campo.valores.map(({ id, descricao }) => ({
                      id,
                      descricao: <span title={descricao}>{descricao}</span>,
                    })),
                  label: intl.formatMessage({
                    id: 'labelSelecioneUmaOpcao',
                  }),
                  requestChange: (value) =>
                    handleLookupChangeMulti(index, value),
                }}
              />
            </div>
            {renderJustificativa(item, index, errors, disabled)}
            {renderAnexarEvidencia(item, index, errors, disabled)}
          </FormGroup>
        );
      } else {
        let value =
          item.campo.opcoesTabela &&
          item.campo.opcoesTabela.find((op) => op.id == item.valor)
            ? item.campo.opcoesTabela.find((op) => op.id == item.valor)
            : null;
        return (
          <FormGroup>
            {renderHeader(item, required, index)}
            <div className="pt-2 pb-2" />
            <Lookup
              required={required}
              onBlur={rest.getAlteracao}
              disabled={disabled || item.disabled}
              options={item.campo.opcoesTabela}
              model={{
                errors: errors && !disabled && !item.disabled,
                value: value,
                label: intl.formatMessage({
                  id: 'labelSelecioneUmaOpcao',
                }),
                requestChange: (value) => handleLookupChange(index, value),
              }}
            />
            {renderJustificativa(item, index, errors, disabled)}
            {renderAnexarEvidencia(item, index, errors, disabled)}
          </FormGroup>
        );
      }
    }
  };

  return model.value ? (
    colValue ? (
      <Row>
        {model.value.map((item, index) => (
          <Col md={colValue} key={index}>
            {desenharCampoCustomizado(item, index, desconsiderarObrigatorio)}
          </Col>
        ))}
        {utilizarRelacionamentoItens && (
          <Col md={12} style={{ marginTop: 20 }}>
            <Panel
              header={intl.formatMessage({ id: 'itensAssociados' })}
              className="panel-background-color-dark-blue-green"
              marginBottomCard={35}
              headerStyle={{
                color: '#FFF',
                fontWeight: 400,
                paddingLeft: '0.75rem',
              }}
            >
              <TabelaItensAssociados
                handleNewClick={handleOpenItensAssociados}
                allowNew={usuarioPodeModificarItensAssociados}
                model={{
                  value: itensAssociados,
                  requestChange: onChangeItensAssociados,
                }}
              />
            </Panel>
          </Col>
        )}
        {utilizarPlanoAcao && (
          <Col>
            {renderHeaderPlanoAcao()}
            <AcaoList
              showHeaderPanel={false}
              showDelete={false}
              params={{
                perdaOperacionalId: perdaOperacionalId,
                exibirLookups: false,
                itemNaoObrigatorio: true,
                apenasAcoesModuloAtual: true,
              }}
              showMenuAcao={false}
              showPrevious={false}
              showLink={true}
              showNew={usuarioPodeModificarPlanoAcao}
              disabled={!usuarioPodeModificarPlanoAcao}
              showExport={true}
              autoFocus={false}
            />
          </Col>
        )}
      </Row>
    ) : (
      <Row>
        {model.value.map((item, index) => (
          <Col
            md={
              item.campo &&
              item.campo.tipo &&
              (item.campo.tipo.id == TIPO_CAMPO_CUSTOMIZADO.TEXTO ||
                item.campo.tipo.id == TIPO_CAMPO_CUSTOMIZADO.MULTILINHA) &&
              (!mdFieldsTo || mdFieldsTo.find((x) => x === item.campo.tipo.id))
                ? 12
                : mdFields
            }
            key={index}
          >
            {desenharCampoCustomizado(item, index, desconsiderarObrigatorio)}
          </Col>
        ))}
        {utilizarRelacionamentoItens && (
          <Col md={12} style={{ marginTop: 20 }}>
            <Panel
              header={intl.formatMessage({ id: 'itensAssociados' })}
              className="panel-background-color-dark-blue-green"
              marginBottomCard={35}
              headerStyle={{
                color: '#FFF',
                fontWeight: 400,
                paddingLeft: '0.75rem',
              }}
            >
              <TabelaItensAssociados
                handleNewClick={handleOpenItensAssociados}
                allowNew={usuarioPodeModificarItensAssociados}
                model={{
                  value: itensAssociados,
                  requestChange: onChangeItensAssociados,
                }}
              />
            </Panel>
          </Col>
        )}
        {utilizarPlanoAcao && (
          <Col>
            {renderHeaderPlanoAcao()}
            <AcaoList
              showHeaderPanel={false}
              showDelete={false}
              params={{
                perdaOperacionalId: perdaOperacionalId,
                exibirLookups: false,
                itemNaoObrigatorio: true,
                apenasAcoesModuloAtual: true,
              }}
              showMenuAcao={false}
              showPrevious={false}
              showLink={true}
              showNew={usuarioPodeModificarPlanoAcao}
              disabled={!usuarioPodeModificarPlanoAcao}
              showExport={true}
              autoFocus={false}
            />
          </Col>
        )}
      </Row>
    )
  ) : (
    <div></div>
  );
}

PerguntasCampoCustomizado.defaultProps = {
  colValue: null,
  mdFields: 3,
  ignoreErrors: false,
};
